export const UserCarBookingData = [
  {
    key: "1",
    id: "#CB-1245",
    carimage:"assets/img/cars/car-01.jpg",
    carname: "Volkswagen Amarok",
    cartype:"Sedan",
    travellers:"2 Adults, 1 Child",
    day:"4 Days",
    pricing:"$1,569",
    date:"15 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "2",
    id: "#CB-3215",
    carimage:"assets/img/cars/car-06.jpg",
    carname: "Toyota Camry SE 400",
    cartype:"Hatchback",
    travellers:"2 Adults, 2 Child",
    day:"3 Days",
    pricing:"$1,745",
    date:"20 May 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "3",
    id: "#CB-4581",
    carimage:"assets/img/cars/car-07.jpg",
    carname: "Ford Mustang 4.0 AT",
    cartype:"Coupe",
    travellers:"2 Adults, 1 Child",
    day:"2 Days",
    pricing:"$2,160",
    date:"04 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "4",
    id: "#CB-6545",
    carimage:"assets/img/cars/car-08.jpg",
    carname: "Ferrari 458 MM Special",
    cartype:"SUV",
    travellers:"1 Adult, 1 Child",
    day:"2 Days",
    pricing:"$1,840",
    date:"17 Jun 2025",
    status:"Pending",
    action:"pending",
  },
  {
    key: "5",
    id: "#CB-3256",
    carimage:"assets/img/cars/car-09.jpg",
    carname: " Mercedes-benz",
    cartype:"Sports",
    travellers:"2 Adults, 1 Child",
    day:"3 Days",
    pricing:"$1,450",
    date:"25 Jun 2025",
    status:"Upcoming",
    action:"upcoming",
  },
  {
    key: "6",
    id: "#CB-3654",
    carimage:"assets/img/cars/car-10.jpg",
    carname: "BMW 3.0 Gran Turismo",
    cartype:"Hatchback",
    travellers:"3 Adults, 2 Child",
    day:"4 Days",
    pricing:"$1,600",
    date:"02 Jul 2025",
    status:"Cancelled",
    action:"cancelled",
  },
  {
    key: "7",
    id: "#CB-1458",
    carimage:"assets/img/cars/car-11.jpg",
    carname: "Infiniti QX60",
    cartype:"Hatchback",
    travellers:"2 Adults, 2 Child",
    day:"5 Days",
    pricing:"$2,380",
    date:"12 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "8",
    id: "#CB-6589",
    carimage:"assets/img/cars/car-12.jpg",
    carname: "Toyota 86 Coupe",
    cartype:"Sedan",
    travellers:"2 Adults, 1 Child",
    day:"3 Days",
    pricing:"$1,400",
    date:"26 Jul 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "9",
    id: "#CB-2315",
    carimage:"assets/img/cars/car-13.jpg",
    carname: "Jeep Wrangler",
    cartype:"Coupe",
    travellers:"2 Adults, 2 Child",
    day:"2 Days",
    pricing:"$1,810",
    date:"10 Aug 2025",
    status:"Completed",
    action:"completed",
  },
  {
    key: "10",
    id: "#CB-5414",
    carimage:"assets/img/cars/car-14.jpg",
    carname: "Jaguar XK",
    cartype:"Sedan",
    travellers:"3 Adults, 1 Child",
    day:"2 Days",
    pricing:"$1,450",
    date:"22 Aug 2025",
    status:"Completed",
    action:"completed",
  },
  
 

];
